import isEmpty from 'lodash/isEmpty';
import {
    getOptionalQuestionsForAttendees,
    getOptionalQuestionsForBuyer,
} from '../../selectors/survey/untypedSurveySelectors';
import { WithAppNamespace } from '../../state/app';
import { WithSurveyNamespace } from '../../state/survey';
import { checkEnableOrganizerQuestionsPageInAppsFeatureGate } from '../../utils/statsig';
import { isNativeApp } from '../app';

export const hasOptionalQuestions = <State extends WithSurveyNamespace>(
    state: State,
) =>
    !isEmpty(getOptionalQuestionsForBuyer(state)) ||
    getOptionalQuestionsForAttendees(state).some(
        (attendee) => !isEmpty(attendee.survey),
    );

export const isOrderFormSplittedInTwoPages = <
    State extends WithSurveyNamespace & WithAppNamespace,
>(
    state: State,
): boolean =>
    checkEnableOrganizerQuestionsPageInAppsFeatureGate()
        ? hasOptionalQuestions(state)
        : !isNativeApp(state) && hasOptionalQuestions(state);
